import React, { Component } from 'react';

class FlexCenter extends Component {
  render(){
    var p = this.props, s = this.state;
    return (
      <div style={{width: this.props.width, ...style.frame}}>
            {p.children}
      </div>
    )
  }
}

export default FlexCenter;

var style = {
  frame: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/FlexCenter.js